import { useFormikContext } from 'formik';
import { useMemo } from 'react';
import {
  CustomizeAssetLayout,
  type CustomizeAssetTab,
} from './CustomizeAssetLayout';
import type { CustomizeModalFormState } from './CustomizeModal';
import { SpeakerNotesTab } from './SpeakerNotesTab';
import { VariablesTab } from './VariablesTab';

type CustomizeDemoProps = { entityId: string };

export const CustomizeDemo = ({ entityId }: CustomizeDemoProps) => {
  const { values } = useFormikContext<CustomizeModalFormState>();
  const tabs = useMemo<CustomizeAssetTab[]>(
    () => [
      {
        id: 'variables',
        label: 'Variables',
        content: (
          <VariablesTab
            entityId={entityId}
            entityType="demo"
            variables={values.variables?.[entityId]}
          />
        ),
      },
      {
        id: 'speakerNotes',
        label: 'Notes',
        content: (
          <SpeakerNotesTab
            entityId={entityId}
            entityType="demo"
          />
        ),
      },
    ],
    [values, entityId]
  );

  return <CustomizeAssetLayout tabs={tabs} />;
};
